<template>
  <div>
    <v-row id="router" class="ma-0 pa-0" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">下載場次資訊</th>
                <th class="text-center">下載場次證書</th>
                <th @click="sort('examNo')" class="text-center">場次代碼<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examDate')">認證日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('applyName')">申請人<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('company')">認證考場<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class1')">認證項目<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class2')">認證模組<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class3')">認證廠商<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('numOfApplicants')">已報名人數<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index">
                <td style="min-width: 130px">
                  <v-btn class="ma-1" outlined style="color:#FFFFFF; background:#81C0E2; border:none" @click="getDatasetExcel(index)">
                    下載資訊
                  </v-btn>
                </td>
                <td style="min-width: 130px">
                  <v-btn v-if="data.certificatePrintCount=='2'" class="ma-1" outlined style="color:#FFFFFF; background:#215DA7; border:none" @click="getCertificatePdf(index)">
                    下載證書
                  </v-btn>
                </td>
                <td class="pt-2 pb-1 text-center" style="min-width: 130px">
                  <v-btn outlined style="height:28px; background:#215DA7; color:#FFF" @click="redirectPath('/projectManagement', data.id)"><span style="font-size:14px">詳細資訊</span></v-btn>
                  <h4>{{data.examNo}}</h4>
                </td>
                <td style="min-width: 110px"><h4>{{data.examDate}}</h4><h4>{{data.examTime}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.applyName}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.company}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class1}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class2}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class3}}</h4></td>
                <td style="min-width: 120px">
                  <h4>{{data.numOfApplicants}}人</h4>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="px-5 py-0">
        <v-col class="col-0 col-sm-0 col-md-2 col-lg-7 pagination-max pl-5 mt-3 text-right pr-8">共 {{pagination.totalCount}} 筆</v-col>
        <v-col class="col-12 col-sm-8 col-md-6 col-lg-3 pr-0">
          <v-pagination color="#81C0E2" v-model="pagination.page" :length="pagination.totalPage"
          :total-visible="5"></v-pagination>
        </v-col>
        <v-col class="col-12 col-sm-4 col-md-4 col-lg-2">
          <v-row class="row">
            <v-col class="col-5 col-sm-4 pt-3 text-right">前往</v-col>
            <v-col class="col-2 col-sm-4 pa-0">
            <v-text-field outlined dense v-model="destPage" @keyup.enter="setDestPage()"></v-text-field>
            </v-col>
            <v-col class="col-5 col-sm-4 pt-3 text-left">頁</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <LoadingVideo ref="LoadingVideo"/>
  </div>
</template>

<script>
import LoadingVideo from '@/dialogs/LoadingVideo'
export default {
  name: 'ProjectManagementList',
  components: {LoadingVideo},
  mounted(){
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.getDataset()
  },
  data:() => ({
    select:'',
    keyword:'',
    datasets: [],
    pagination:{page:1,totalPage:0,totalCount:0},
    orderBy:'examDate',
    direction:'desc',
    destPage:'',
    showRange:false,
    viewStyle:{},

    memberSearchStatus: false,
    startDate:'',
    endDate:'',
    menuS:'',
    menuE:'',

    applyStatusList: [],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "pagination.page":function(){
      this.getDataset()
    }
  },
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path, id){
      this.$router.push({path: path, query: {id: this.$Global.encrypt(JSON.stringify(id))}})
    },
    setDestPage(){
      this.pagination.page = parseInt(this.destPage)
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamListByIdCard',
        params: {
          'page': self.pagination.page,
          'limit': 10,
          'order': self.orderBy,
          'direction': self.direction,
          'teacherIdCard': sessionStorage.getItem('cerpsMemberIdCard'),
        },
      }
      this.$http(request).then(function(response) {
        if(response.data.msg == '成功!'){
          self.datasets = response.data.data.data
          self.pagination.totalCount = response.data.data.total
          self.pagination.totalPage = response.data.data.page
        }
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjl-7956')
      })
    },
    getDatasetExcel(index){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegPageExcel',
        params: {
          'examNo': self.datasets[index].examNo,
          // 'keyword':self.keyword != ''? self.keyword: null, //manufacturer
          'company': sessionStorage.getItem('cerpsCompany'),
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'export.xls'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets[index].examNo + '_場次成績.xls')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'erpExamRegPageExcel', //type
          self.datasets[index].examNo, //examNo
          '下載場次成績-管理清單', //logContent
          '', //note1
          '', //note2
          '', //note3
        )
      });
    },
    getCertificatePdf(index){
      var self = this
      self.$refs.LoadingVideo.open()
      var request = {
        method: 'GET',
        url: '/certificateDownloadMerge/exportpdf',
        params: {
          'examNo': self.datasets[index].examNo,
          'printType': 'member',
          'company': sessionStorage.getItem('cerpsCompany'),
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets[index].examNo + '_考生證書.rar')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$refs.LoadingVideo.close()
      });
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .pagination-max {
      display: none !important;
    }
  }
</style>